import React from 'react';
import { StaticQuery, Link, graphql } from "gatsby"
import Img from "gatsby-image"
import GridBg from "../../gridBg/gridBg"
import './styles.scss'

const MobileHeader = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                mobilelp {
                  header {
                    description
                    headerImageAlt
                  }
                  application {
                    navigate
                  }
                }
                language
              }
            }
          }
          headerEnImage: file(relativePath: {eq: "mobilelp/mobile-header_en.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 1496, quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          headerJaImage: file(relativePath: {eq: "mobilelp/mobile-header_ja.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 1496, quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          headerHandEnImage: file(relativePath: {eq: "mobilelp/mobile-header-hand_en.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 1125, quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          headerHandJaImage: file(relativePath: {eq: "mobilelp/mobile-header-hand_ja.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 1125, quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          headerScreenshotEnImage: file(relativePath: {eq: "mobilelp/mobile-header-screenshot_en.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 1125, quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          headerScreenshotJaImage: file(relativePath: {eq: "mobilelp/mobile-header-screenshot_ja.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 1125, quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={({ allDataYaml: { edges }, headerEnImage, headerJaImage, headerHandEnImage, headerHandJaImage, headerScreenshotEnImage, headerScreenshotJaImage }) => {
        const { language } = props
        const { node: { mobilelp: { application, header } } } = edges.find(({node}) => node.language === props.language)
        const headerImage = language === "ja" ? headerJaImage : headerEnImage;
        const headerHandImage = language === "ja" ? headerHandJaImage : headerHandEnImage;
        const headerScreenshotImage = language === "ja" ? headerScreenshotJaImage : headerScreenshotEnImage;

        const { description, headerImageAlt } = header

        return <div className="mobile-header">
          <div className="mobile-header d-block d-md-none">
            <div className="mobile-header-image">
              <div className="mobile-header-hand-image">
                <Img
                  alt={headerImageAlt}
                  fluid={headerHandImage.childImageSharp.fluid}
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="mobile-header-hand-slash"></div>
              <div className="mobile-header-screenshot-image">
                <Img
                  alt={headerImageAlt}
                  fluid={headerScreenshotImage.childImageSharp.fluid}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
            <div className="mobile-header-description text-left mx-auto px-4 px-sm-5">{description}</div>
          </div>
          <div className="mobile-md-header d-none d-md-block">
            <div className="mobile-md-header-content">
              <Img
                alt={headerImageAlt}
                className="mobile-md-header-image"
                fluid={headerImage.childImageSharp.fluid}
                loading="lazy"
                decoding="async"
              />
              <div className="header-information">
                <div className="mx-auto">{description}</div>
                <div className="d-flex justify-content-center mt-xl-5 mt-lg-3 mt-md-3">
                  <Link className="header-information-navigation-button btn btn-purple" to="#mobile-application-form" >{application.navigate}</Link>
                </div>
              </div>
            </div>
            <div className="skew-section-line">
              <GridBg color="gray" bottomBgColor="gray" background="white" />
            </div>
          </div>
        </div>
      }}
    />
  )
}

export default MobileHeader
